import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_alert, {
        color: "primary",
        text: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('pages.maintenanceTitle')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('pages.maintenanceMessage')), 1),
          _createVNode(_component_v_divider, {
            class: "info my-6",
            style: {"opacity":"0.22"}
          }),
          _createElementVNode("div", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.maintenanceMessage), 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}